import { render, staticRenderFns } from "./LoadingInput.vue?vue&type=template&id=1b97e513"
import script from "./LoadingInput.vue?vue&type=script&lang=js"
export * from "./LoadingInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports